export default "__VITE_ASSET__ee76eb81__"